import React from "react";
import { useContext } from "react";
import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  select: {
    margin: theme.spacing(-2, 0, 1),
    minWidth: "100%",
  },
}));

const CustomSelect = (props) => {
  const classes = useStyles();
  const { language } = useContext(LanguageContext);
  const options = localize(props.options, language) || [];

  return (
    <>
      <Typography style={{ marginTop: "10px" }}>
        {localize(props.name, language)}
      </Typography>
      <br />
      <Grid container>
        <Grid item xs={6}>
          <FormControl className={classes.select}>
            <InputLabel id={props.name + "Id"}>
              {localize(props.label, language)}
            </InputLabel>
            <Select labelId={props.name + "Id"} id={props.label}>
              {options.map((option, index) => (
                <MenuItem
                  value={option.value}
                  key={`${props.name}Option${index}`}
                >
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}></Grid>
      </Grid>
    </>
  );
};

export default CustomSelect;
